import { render } from "./TrainingView.vue?vue&type=template&id=62ee69cc&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"

import "./TrainingView.vue?vue&type=style&index=0&id=62ee69cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ee69cc"]])

export default __exports__